import { TooltipBoundaries, TooltipOffset, TooltipPosition, TooltipSize } from './types'

export function getTipOffset(
  position: TooltipPosition,
  tooltipBoundaries: TooltipBoundaries,
  viewportSize: TooltipSize,
): TooltipOffset {
  const isVerticalPosition = ['top', 'bottom'].includes(position)

  // In vertical positions, calculating only horizontal offset
  if (isVerticalPosition) {
    const minX = 0
    const maxX = viewportSize.width

    if (tooltipBoundaries.left < minX) {
      return {
        x: tooltipBoundaries.left * -1,
        y: 0,
      }
    }

    if (tooltipBoundaries.right > maxX) {
      return {
        x: (tooltipBoundaries.right - maxX) * -1,
        y: 0,
      }
    }
  }

  // In horizontal positions, calculating only vertical offset
  if (tooltipBoundaries.top < 0) {
    return {
      x: 0,
      y: tooltipBoundaries.top * -1,
    }
  }

  if (tooltipBoundaries.bottom > viewportSize.height) {
    return {
      x: 0,
      y: (tooltipBoundaries.bottom - viewportSize.height) * -1,
    }
  }

  return {
    x: 0,
    y: 0,
  }
}
